import Lightbox from './bs5-lightbox';

const options = {
	keyboard: true
};

document.querySelectorAll('.wp-block-image a[href*="vimeo.com"], .wp-block-image a[href*="youtu.be"]').forEach((el) => el.addEventListener('click', (e) => {
	e.preventDefault();
	const lightbox = new Lightbox(el, options);
	lightbox.show();
}));
//
// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
// import Swiper styles
//import 'swiper/css';

const swiper = new Swiper('.swiper', {
    // Optional parameters
    //direction: 'vertical',
	modules: [Autoplay, Navigation],
    loop: true,
	slidesPerView: 1,
	breakpoints: {
		992:{
			slidesPerView: 2,
			spaceBetween: 24
		}
	},
	autoHeight: true, // Make slides equal height
	autoplay: {
		delay: 10000,
	},
	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
  });